// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
// With the addition of featureEnum variable in the request and response , user can enter either of two to identify the feature.
// Feature enum is placed at location : weave/shared/feature/location_feature.proto . If both values are present then featureId takes
// priority and featureEnum is ignored. The responses of these endpoint will also contain featureEnum in addition to the featureIds.
// Devs can take advantage of it to add conditions around customization flags and also improve readability.
export const PlatformLocationFeature = {
    // Get all the existing customization flags details such as id, name, description, default state 
    Features(fn, req) {
        return fn(`/platform-location-feature/v1/features?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Get all the customization flag setting for a location 
    LocationFeatures(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/platform-location-feature/v1/location/${req["locationId"]}/features?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    // Get a customization flag setting for a location. This endpoint can accept both featureId and featureEnum to identify the feature
    // in the request.One of the feature details is always required to successfully complete the request.
    // If request contains both featureId and featureEnum then featureId wil be given priority
    // and featureEnum will be ignored.
    //FeatureId or FeatureEnum are accepted as query params in the http request
    LocationFeature(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/platform-location-feature/v1/location/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    // Post all customization flag setting for a location (if a customization flag setting is not specified,
    // that flag will be set to its default value for this location). Insertion can also happen on the basis of featureEnum and the
    // usual featureId will also work. FeatureId always takes priority if both are present.
    InsertLocationFeatures(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/platform-location-feature/v1/location/${req["locationId"]}/features`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // returns the flag status (hide, active, promote) change history for a given feature, location 
    LocationFeatureHistory(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/platform-location-feature/v1/location/${req["locationId"]}/history?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    // returns the FeaturesResponse for all the location ids passed in the request. will also filter the request if customisations are passed in request
    LocationsFeatures(fn, req) {
        return fn(`/platform-location-feature/v1/locations/features?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // ================== Trial related endpoints ====================
    // TrialBannerUserAction stores the actions taken by the user on the trial banner. This data will be used
    // to decide whether to show the banner again or not 
    TrialBannerUserAction(fn, req) {
        return fn(`/platform-location-feature/v1/trial/banner/user/action`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // GetTrialStageBanner Takes location, user ID as input and determines which trial stage banner to show based
    // on user action, trial stage
    GetTrialStageBanner(fn, req) {
        return fn(`/platform-location-feature/v1/trial/banner/stage?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // TrialSignup Activates the free trial for the given location, feature. No. of days for trial is configured in the DB per feature
    TrialSignup(fn, req) {
        return fn(`/platform-location-feature/v1/trial/signup`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    //TrialTaskUserAction store the user action taken for the task. This information will be used in GetTrialTasks endpoint
    TrialTaskUserAction(fn, req) {
        return fn(`/platform-location-feature/v1/trial/task/user/action`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    //GetTrialTasks returns the list of task for the give location, feature and user ID, indicating whether task is completed
    // successfully or not. 
    GetTrialTasks(fn, req) {
        return fn(`/platform-location-feature/v1/trial/tasks?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    //IsEligibleForFreeTrial returns whether the given location, feature is eligible for free trial or not
    IsEligibleForFreeTrial(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/platform-location-feature/v1/trial/${req["locationId"]}/isEligible?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    //GetDesktopClientTrialStatus returns whether to show the trial banner and free trial icon in desktop client
    GetDesktopClientTrialStatus(fn, req) {
        return fn(`/platform-location-feature/v1/trial/desktopClient/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // GetTrialHistory returns the trial history for the given location
    GetTrialHistory(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/platform-location-feature/v1/trial/${req["locationId"]}/history?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetTrialHistoryForMulti(fn, req) {
        return fn(`/platform-location-feature/v1/trial/multi/history?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Multiple location endpoints
    // TrialSignup Activates the free trial for the given location, feature. No. of days for trial is configured in the DB per feature
    MultiLocationsTrialSignup(fn, req) {
        return fn(`/platform-location-feature/v1/trial/multi/signup`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // CreateOrUpdateFeatureNotificationUserAction stores the user action for a given feature notification such as toast, banner, teaser, etc.
    CreateOrUpdateFeatureNotificationUserAction(fn, req) {
        return fn(`/platform-location-feature/v1/notification/user/action`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // CheckFeatureNotificationStatus gives the possible list of actions for a given feature notification
    CheckFeatureNotificationStatus(fn, req) {
        return fn(`/platform-location-feature/v1/notification/user/action?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
